import React, { PropsWithChildren, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TooltipPlacement } from '../../../../components/atoms/Tooltip';
import { ButtonMinorAction } from '../../../../components/molecules/Btn/ButtonWrapper';
import { Icons } from '../../../../components/atoms/SVG';
import { AcceptDeclineForm, SonForm } from '../../../Form2';
import ModalDialog from '../../../../components/organisms/ModalDialog/ModalDialog';
import { RefreshCallback } from '../../../FetchContainer';
import { useDelayed } from '../../../../hooks/useDelayed';

type DeletableItemProps = PropsWithChildren<{
  id: string;
  namespace: string;
  name?: string;
  position?: number;
  numberOfItems?: number;
  removeForm: SonForm<any>;
  refresh?: RefreshCallback;
}>;

export function DeletableItem({
  namespace,
  children,
  id,
  name,
  position,
  numberOfItems,
  removeForm,
  refresh,
}: DeletableItemProps) {
  const [showModal, setShowModal] = useState<boolean>();
  const delayedCloseModal = useDelayed(() => setShowModal(false));
  const { t } = useTranslation();

  return (
    <>
      <div className="deletable-item-list__item" key={`page-${id}`}>
        <div className="deletable-item-list__content">
          <div className="deletable-item-list__content-container">{children}</div>
          <div className="deletable-item-list__button">
            <ButtonMinorAction
              icon={Icons.DELETE_X_SMALL}
              text={t(`${namespace}.remove`, { name, position, numberOfItems })}
              onClick={() => setShowModal(true)}
              tooltipPlacement={TooltipPlacement.TOP}
            />
          </div>
        </div>
      </div>
      {showModal ? (
        <ModalDialog
          closeModal={() => setShowModal(false)}
          headline={t(`${namespace}.remove`, { name, position, numberOfItems })}
          initialFocusIndex={1}
        >
          <AcceptDeclineForm
            headline={t(`${namespace}.removeQuestion`, { name, position, numberOfItems })}
            form={removeForm}
            onSuccess={() => {
              delayedCloseModal();

              if (typeof refresh === 'function') {
                refresh();
              }
            }}
            messageSuccess={t(`${namespace}.status.success`)}
            messageSending={t(`${namespace}.status.sending`)}
            messageFail={t(`${namespace}.status.fail`)}
          />
        </ModalDialog>
      ) : null}
    </>
  );
}
